

/* profile-menu-dialog.component.ts */
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { CategorySelected, CategorySelectorComponent } from './category-selector';
import { MatIconModule } from '@angular/material/icon';

export interface CategorySingleSelectorData {
  category?: CategorySelected;
}

@Component({
  selector: 'msh-single-select-dialog',
  standalone: true,
  imports: [CategorySelectorComponent, MatIconModule, MatDialogModule, MatButtonModule, RouterModule],
  template: `
<div class=" z-10 relative">
  <mat-icon class="absolute top-4 right-4" [mat-dialog-close]="false">close</mat-icon>
</div>
<div class="dialog-container relative p-4 overflow-auto max-h-96 w-screen md:w-auto md:min-w-80">
  <msh-category-selector
    [mode]="'single'"
    [selectedCategoryNames]="data.category ? [data.category.name] : []"
    (onSelectCategory)="onSelectCategory($event)"
  ></msh-category-selector>
</div>

<div class="bg-navy-50 gap-4 py-4 px-6">
    <button [disabled]="!data.category" mat-flat-button color="accent" [mat-dialog-close]="data.category">
      Confirm{{ data.category ? ': ' + data.category.name : ''}}
    </button>
</div>
  `,
  styles: ``
})
export class CategorySingleSelectorDialog {
  
  constructor(
    public dialogRef: MatDialogRef<CategorySingleSelectorDialog>,
    @Inject(MAT_DIALOG_DATA) public data: CategorySingleSelectorData,
  ){}

  onSelectCategory(categories: CategorySelected[]){
    this.data.category = categories[0];
  }
}
